// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"37":"2175b8a173988714cf38","53":"2a4ed4aff514c2d2c904","246":"77aedd41ff948d3d96ca","277":"8bb9be54c4e6eba60916","832":"24c757284886ca0f425e","940":"8e0e06f3ec408cea502d"}[chunkId] + ".js";
};